
import { UseFormReturn } from "react-hook-form";
import { DTOModule } from "../../types/building";

interface IProps {
  module: DTOModule;
  data: any;
  formHook: UseFormReturn;
}

const ConfigNoConfiguration = ({ module, data, formHook }: IProps) => {
   
  return (
    <>
      <div className="row ml-0">
        <div className="col-lg-12">
          Här finns det inget som behöver konfigureras
        </div>
      </div>
    </>
  );
};

export default ConfigNoConfiguration;
